<template>
    <div id="contendor-principal-emplazamientoDeCedula">
        <div id="contenedor-encabezados-cancelacionDeCedula" class="text-left">
            <h1>EMPLAZAMIENTO DE CEDULA</h1>
            <h3>Ingrese la información requerida para realizar el emplazamiento de una cedula</h3>
         </div>
         <div id="contendor-emplazamiento-cedula" class="padding-div-low">
            <div id="filtros-emplazamientoCedula" class="col-4">
               <FiltrosDeBusqueda class="area"
                :catalogos="filtrosDeBusqueda" 
                :ejecutaLaFuncion="buscarCedula" 
                :filtrosEstablecidos="filtrosEstablecidos"
                :tituloDeBusqueda="'Filtros para busqueda de cedula'"></FiltrosDeBusqueda>
           </div>
            <div v-if="true"  class="area col-8">
                <h4 style="margin-bottom: 1em;">Ingrese la informacion del formulario de emplazamiento de cedula</h4>
                <CDescripcionBasicaDeCedula class="contenedor-color-negro"
                    v-on:cambiarDeCedula="cambiarCedula"
                    :idDelInput="COMPONENTE_DESCRIPCION_CEDULA_ID"
                    :numeroDeExpediente="'00/01'"
                    :DireccionCorrespondiente="'notificadores'"
                    :esUrgente="'SI'"
                    :numeroDeAcuerdos="2"
                    :NombreDeDocumento="'DocumentoPrueba.pdf'"
                    :acciones="ACCIONES_DESCRIPCION_CEDULA"
                    :encabezado="DESCRIPCION_CEDULA_ENCABEZADO + '[#Folio: ' + numeroFolio + ']'">
                </CDescripcionBasicaDeCedula>
                <div id="formulario-emplazamiento" class="contenedor-color-negro">
                    <h5>Formulario de emplazamiento</h5>
                    <hr />
                    <h6>Observaciones</h6>
                    <CEditorTexto
                        :idDelInput="'editor-id-emplazamiento'"
                        :altura="'230px'"
                        :valorEditor="contenidoDelEditor"
                        v-on:cambioContenido="contenidoDelEditor = $event"
                        :barraHerramientas="BARRA_HERRAMIENTAS_EDITOR"></CEditorTexto>
                    <!-- <textarea  v-model="observacionesEmplazamiento" type="text" rows="6" class="form-control" placeholder="Ingrese las observaciones del emplazamiento" /> -->
                    <hr />
                    <h6>Seleccione un documento para el emplazamiento</h6>
                    <input type="file" id="archivo-emplazamiento" class="form-control" v-on:change="agreagarArchivoEmplazamiento($event)" accept=".PDF,.XLSX,.XLSB,.ZIP" />
                    <hr />
                    <div class="text-right">
                        <div>
                            <button type="button" class="btn btn-primary" @click="realizarEmplazamientoDeCedula"><i class="fas fa-save"></i>&nbsp;&nbsp;Realizar Emplazamiento</button>
                        </div> 
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
/* Utilizar cuando este desarrollada la API del sistemas
import axios from 'axios' */ 

export default {
     components: {
        FiltrosDeBusqueda: sistemas.SINOJ.FiltrosDeBusqueda,
        CDescripcionBasicaDeCedula: sistemas.SINOJ.CDescripcionBasicaDeCedula,
        CEditorTexto: sistemas.SINOJ.CEditorTexto
    },
    data() {
        return {
            observacionesEmplazamiento: '',
            COMPONENTE_DESCRIPCION_CEDULA_ID: 'contenedor-descripcion-cedula-emplazamiento',
            ACCIONES_DESCRIPCION_CEDULA: { mostrar: true, cambiar: true},
            DESCRIPCION_CEDULA_ENCABEZADO: 'Cedula ',
            mostrarCedulaYformulario: false,
            documentoDeEmplazamiento: null,
            filtrosDeBusqueda: [
                { 
                    catalogoId: 'filtroNumeroFolio',
                    idDelInput: 'inputNumeroDeFolioEmplazamiento'
                },
                { 
                    catalogoId: enumeraciones.catalogos.Consecutivo, 
                    idDelInput: 'inputjuzgadoEmplazamiento' 
                }, 
                { 
                    catalogoId: 'filtroPersona',
                    idDelInput: 'inputPersonaEmplazamiento'
                }
            ],
            filtrosEstablecidos: {},
            numeroFolio: '0001',
            contenidoDelEditor: 'prueba',
            BARRA_HERRAMIENTAS_EDITOR: {
                undo: true, redo: true, size: true,font:false, bold: true, italic: false, strike: false, underline: true, bold: true, alignLeft: true, alignCenter: true,
                alignRight: true, alignJustify: true, alignLeft: true, orderedList: true, bulletList: true, header: false, color: false, background: false, link: false, image: false, 
                clear: false, codeBlock: false, blockquote: false
            }
        }
    },
    methods: {
        /**
         * funcion para cambiar de cedula
         * @param {object} evento [evento emitido por componente hijo CDescripcionBasicaDeCedula {@link #COMPONENTE_DESCRIPCION_CEDULA_ID}]
         */
        cambiarCedula: function(evento) {
            $("#" + 'filtros-emplazamientoCedula').removeClass("desabilitar-contenedor-buscarCedula");
            this.mostrarCedulaYformulario = false;
        },
         /**
         * funcion para realizar la realizar Emplazamiento De Cedula de la cedula
         */
        realizarEmplazamientoDeCedula: function() {

        },
         /**
         * funcion para realizar busqueda de una cedula
         * @param {object} evento [evento emitido por componente hijo CBusquedaDeCedula {@link #COMPONENTE_BUSQUEDA_CEDULA_ID}]
         */
        buscarCedula: function(evento,filtrosDeBusqueda) {
            $("#" + 'filtros-emplazamientoCedula').addClass("desabilitar-contenedor-buscarCedula");
            this.mostrarCedulaYformulario = true;
        },
         /**
         * funcion encargada de guardar el archivo como objeto blob en memoria
         * @param {object} evento [evento emitido por input file {@link #archivo-emplazamiento}]
         */
        agreagarArchivoEmplazamiento: function(evento) {
            try {
                if(evento.target.files.length > 0) 
                    this.documentoDeEmplazamiento = evento.target.files[0];
                else 
                    this.documentoDeEmplazamiento = null;
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        }
    },
}
</script>
<style scoped>
.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

#contendor-emplazamiento-cedula {
    display: flex;
}

#formulario-emplazamiento {
    margin-top: 2em;
}

.desabilitar-contenedor-buscarCedula {
    pointer-events: none;
    opacity: 0.4;
}
</style>    


// WEBPACK FOOTER //
// src/components/SINOJ/Cedulas/ManejoDeCedulas/Emplazamiento/CEmplazamientoDeCedula.vue